import { OnInit, Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms' 
@Directive({
  selector: '[appRut]'
})
export class RutDirective implements OnInit {

  input:HTMLInputElement;
  constructor(
    public control:NgControl,
    private elementRef: ElementRef) { }

  ngOnInit(): void {
    this.input = this.elementRef.nativeElement;
    this.input.maxLength = 10;
    this.input.minLength = 8;
  }
   
  @HostListener('input', ['$event']) changeForm() {
    const cadena = this.control.control.value.replace(/[^0-9K-]/g, '');
    this.control.control.setValue(cadena)
  
  }
}
